// $('#ActuSlider').owlCarousel({
//     autoplay:true,
//     autoplayTimeout:5000,
//     autoplayHoverPause:true,
//     autoplaySpeed:5000,
//     loop:true,
//     margin: 136,
//     nav:true,
//     navText: ['<i class="fa-light fa-long-arrow-up" aria-hidden="true"></i>','<i class="fa-light fa-long-arrow-down" aria-hidden="true"></i>'],
//     singleItem: true,
//     animateOut: 'slideOutLeft',
//     animateIn: 'slideInRight',
//     dots:false,
//     responsive:{
//         0:{
//             items:1
//         },
//         600:{
//             items:2
//         },
//         1000:{
//             items:3
//         }
//     }
// });




// var eventList = new Vue({
//     el: '#Eventlist',
//     data: {
//         EventItems: []
//     },
//     mounted: function() {
//         var self = this;
//         $.ajax({
//             //url: '@Url.Action("GetItems", "Settings")',
//             url: site_url + 'animations/json/',
//             dataType: 'json',
//             method: 'GET',
//             success: function(data) {
//                 self.EventItems = data.items.slice(0, 4);
//                 $(this).imagesLoaded(function() {
//                     $(".verticalCarousel").verticalCarousel({
//                         currentItem: 1,
//                         showItems: 4,
//                     });
//                 });

//             },
//             error: function(error) {
//                 console.log(JSON.stringify(error));
//             }
//         });
//     }
// });
$(".verticalCarousel").verticalCarousel({
    currentItem: 1,
    showItems: 4,
});

// var eventListMobile = new Vue({
//     el: '#EventlistMobile',
//     data: {
//         EventItems: []
//     },
//     mounted: function() {
//         var self = this;
//         $.ajax({
//             //url: '@Url.Action("GetItems", "Settings")',
//             url: site_url + 'animations/json/',
//             dataType: 'json',
//             method: 'GET',
//             success: function(data) {
//                 self.EventItems = data.items.slice(0, 4);
//                 $(this).imagesLoaded(function() {
//                     $('.slider-eventListMobile').owlCarousel({
//                         loop: true,
//                         margin: 20,
//                         nav: true,
//                         navText: ['<i class="fa-light fa-long-arrow-left" aria-hidden="true"></i>', '<i class="fa-light fa-long-arrow-right" aria-hidden="true"></i>'],
//                         responsive: {
//                             0: {
//                                 items: 1
//                             },
//                             600: {
//                                 items: 3
//                             },
//                             1000: {
//                                 items: 6
//                             }
//                         }
//                     });
//                 });

//             },
//             error: function(error) {
//                 console.log(JSON.stringify(error));
//             }
//         });
//     }
// });
// $('.slider-eventListMobile').owlCarousel({
//     loop: true,
//     margin: 20,
//     nav: true,
//     navText: ['<i class="fa-light fa-long-arrow-left" aria-hidden="true"></i>', '<i class="fa-light fa-long-arrow-right" aria-hidden="true"></i>'],
//     responsive: {
//         0: {
//             items: 1
//         },
//         600: {
//             items: 3
//         },
//         1000: {
//             items: 6
//         }
//     }
// });